import {useEffect} from 'react'
import useTagManager from '../../hooks/use-tag-manager'
import useMonetate from '../../hooks/use-monetate'

const PopupAnalytics = () => {
    const monetate = useMonetate()
    const tagManager = useTagManager()
    const getTimer = (key) => {
        var time = localStorage.getItem(key)

        if (time == null) {
            time = 0
        }
        return time
    }
    const getLocalStorage = (key) => {
        var localStoreData = localStorage.getItem(key)

        if (localStoreData !== null) {
            localStoreData = parseInt(localStoreData)
        } else {
            localStoreData = 0
        }

        return localStoreData
    }

    const setLocalStorage = (key, count) => {
        localStorage.setItem(key, count)
    }

    const isTimerExpire = (key) => {
        const timeLimit = 30 //minutes
        var timerExpire = false
        var time = getTimer(key)

        if (time == 0) {
            return timerExpire
        }
        var savedTime = new Date(time)
        var currentTime = new Date()

        var timeDiff = (((currentTime - savedTime) % 86400000) % 3600000) / 60000

        if (timeDiff > timeLimit) {
            timerExpire = true
        }
        return timerExpire
    }

    useEffect(() => {
        const observer = new MutationObserver(() => {
            // If user clicks the chat icon, we'll set this variable to true for Monetate tracking
            if (window.iAdvizeCallbacks) {
                window.iAdvizeCallbacks = {
                    ...window.iAdvizeCallbacks,
                    onChatDisplayed() {
                        monetate.setUsedChatBot()
                        if (typeof window.iAdvize === 'undefined') {
                            return false
                        }
                        var iAdvizePopUpCount = 1
                        var allPopUpCount = 1

                        if (!isTimerExpire('iAdvizeTimer')) {
                            iAdvizePopUpCount = getLocalStorage('iAdvizeCount') + 1
                            allPopUpCount = getLocalStorage('allPopUpCount') + 1
                        }
                        setLocalStorage('iAdvizeTimer', new Date())
                        setLocalStorage('iAdvizeCount', iAdvizePopUpCount)
                        setLocalStorage('allPopUpCount', allPopUpCount)
                        tagManager.popUpshown('iAdvise', iAdvizePopUpCount, allPopUpCount)
                    }
                }
                observer.disconnect() // Stop observing once set
            }
        })
        observer.observe(document, {childList: true, subtree: true})
        return () => observer.disconnect() // Cleanup on unmount
    }, [])

    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.tagName === 'DIV' && node.classList.contains('bx-type-overlay')) {
                        try {
                            window.bouncex?.clientEvents?.onEvent('Impression', () => {
                                // Ensure this runs only if an overlay popup exists
                                if (!document.querySelector('.bx-type-overlay')) return

                                let wunderkindPopUpCount = 1
                                let allPopUpCount = 1

                                if (!isTimerExpire('wunderkindTimer')) {
                                    wunderkindPopUpCount = getLocalStorage('wunderkindCount') + 1
                                    allPopUpCount = getLocalStorage('allPopUpCount') + 1
                                }

                                setLocalStorage('wunderkindTimer', new Date())
                                setLocalStorage('wunderkindCount', wunderkindPopUpCount)
                                setLocalStorage('allPopUpCount', allPopUpCount)

                                tagManager.popUpshown(
                                    'Wunderkind',
                                    wunderkindPopUpCount,
                                    allPopUpCount
                                )
                            })
                        } catch (e) {
                            console.error('Error in Wunderkind observer:', e)
                        }
                    }
                })
            })
        })

        observer.observe(document.body, {attributes: true, childList: true})

        return () => observer.disconnect()
    }, [])

    return null
}

export default PopupAnalytics
